import { render, staticRenderFns } from "./OrganCertificateManage.vue?vue&type=template&id=7ff382ba&scoped=true"
import script from "./OrganCertificateManage.vue?vue&type=script&lang=js"
export * from "./OrganCertificateManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff382ba",
  null
  
)

export default component.exports